// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"852993aa","734":"0f0716d7","743":"cf103b21"}[chunkId] + ".chunk.js";
};